import React from 'react';

function SearchSection({ title, bg, slicer, children, setter, selected, value, setValue }) {
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child) && typeof child.type !== 'string') {
            return React.cloneElement(child, {
                setter: child.props.setter ? setValue : setter,
                selected: child.props.selected ? value : selected,
                auth: true,
            });
        }
        return child;
    });

    return (
        <section
            className="search-drawer-band"
            style={bg ? {padding: '8px 10px', background: bg} : undefined}
        >
            {title && <div className="search-drawer-band__title">{title}</div>}
            {slicer && !title && <div className="search-drawer-band__title-spacer"/>}
            <div className="search-drawer-band__fields search-section search-drawer-fields">
                {childrenWithProps}
            </div>
        </section>
    );
}

export default SearchSection;
